<div class="header d-flex text-center justify-content-center position-relative">
    <span class="titleModal">{{ titleModal }}</span>
    <em (click)="closeModal()" *ngIf="isClosable" class="icon-cross position-absolute modal-icon-close" type="button"></em>
</div>
